import React from "react";
import { NavLink } from "react-router-dom";
import { FiX } from "react-icons/fi";
import { FaWhatsapp, FaPhone } from "react-icons/fa";
import { navLinks } from "./navLinks";
import venueData from "../../data/venueData";

/**
 * MobileOffcanvasMenu — full-height plum panel with a small link
 * stagger, using Bootstrap's offcanvas markup/behavior.
 */
export default function MobileOffcanvasMenu({ id = "mobileNav", onNavigate }) {

  const closeOffcanvas = () => {
    // Method 1: Using Bootstrap's API (preferred)
    const offcanvasElement = document.getElementById(id);
    if (offcanvasElement) {
      // Try to get the Bootstrap instance
      const instance = window.bootstrap?.Offcanvas?.getInstance(offcanvasElement);
      if (instance) {
        instance.hide();
        return;
      }
    }

    // Method 2: Manual close (fallback)
    const offcanvas = document.getElementById(id);
    if (offcanvas) {
      offcanvas.classList.remove('show');
      document.body.classList.remove('offcanvas-open');
      document.body.style.overflow = '';

      // Remove backdrop
      const backdrop = document.querySelector('.offcanvas-backdrop');
      if (backdrop) {
        backdrop.remove();
      }
    }
  };

  const handleNavigation = (e) => {
    // Close the offcanvas first
    closeOffcanvas();

    // Call the onNavigate callback if provided
    if (onNavigate) {
      onNavigate();
    }
  };

  return (
    <div
      className="offcanvas offcanvas-end beejees-offcanvas"
      tabIndex="-1"
      id={id}
      aria-labelledby={`${id}Label`}
    >
      <div className="offcanvas-header">
        <span id={`${id}Label`} className="offcanvas-logo">Beejees</span>
        <button
          type="button"
          className="offcanvas-close-btn"
          onClick={closeOffcanvas}
          aria-label="Close menu"
        >
          <FiX size={26} />
        </button>
      </div>
      <div className="offcanvas-body">
        <ul className="offcanvas-links">
          {navLinks.map((link, i) => (
            <li key={link.to} style={{ transitionDelay: `${i * 45}ms` }}>
              <NavLink
                to={link.to}
                end={link.to === "/"}
                onClick={handleNavigation}
              >
                {link.label}
              </NavLink>
            </li>
          ))}
        </ul>

        <NavLink
          to="/plan-your-event"
          className="btn-beejees-primary offcanvas-cta"
          onClick={handleNavigation}
        >
          Plan Your Event
        </NavLink>

        <div className="offcanvas-contact">
          <a href={`tel:${venueData.contact.phonePrimary}`}>
            <FaPhone /> {venueData.contact.phonePrimary}
          </a>
          <a href={`https://wa.me/${venueData.contact.whatsapp.replace(/\D/g, "")}`}>
            <FaWhatsapp /> WhatsApp us
          </a>
          <p className="offcanvas-address">{venueData.address.full}</p>
        </div>
      </div>
    </div>
  );
}
